import { SprdUser } from '@/types';
import { CoreActionTypes, SetUserAction } from '../types';

export const setUserAction = (user: SprdUser): SetUserAction => ({
  type: CoreActionTypes.SET_USER,
  payload: user,
});
